// 详情中的头部搜索框
<template>
  <div class="header">
    <div class="inner">
      <div class="back">
        <i class="el-icon-back" @click="toHome"></i>
      </div>
      <div class="center">
        <div class="header_center">
          <div class="header_box">
            <!-- 搜索栏 -->
            <div class="box_seach">
              <i class="el-icon-search"></i>
              <input type="text" v-model="keyword" @keyup.enter="search" placeholder="搜索内容..." />
              <div class="button" @click="search">搜索</div>
            </div>
          </div>
        </div>
      </div>
      <div class="txt">{{ type | titleFormat }}</div>
    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      keyword: '',
    }
  },
  props: {
    type: {
      type: Number|String,
      default: 0
    }
  },
  methods: {
    // 前往首页
    toHome () {
      this.$router.go(-1)
      // this.$router.push({ path: '/' })
    },
    // 搜索
    search () {
      this.$router.push({
        path: '/search?keyword=' + this.keyword + '&type=' + this.urlMsg.type
      })
    },
  },
  filters: {
    titleFormat (val) {
      val = Number(val)
      if (val === 1) {
        return '模板'
      } else if (val === 2) {
        return '字体'
      } else if (val === 3) {
        return '动画'
      } else if (val === 4) {
        return '视频'
      } else if (val === 5) {
        return '音乐'
      } else if (val === 6) {
        return '3D模型'
      } else if (val === 7) {
        return '音效'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  height: 100px;
  .inner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    max-width: 1080px;
    margin: 0 auto;
    box-sizing: border-box;
    min-width: 864px;
    padding: 0 3%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0 1px 1px #e0e0e0;
    z-index: 1000;
  }

  .back {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // position: absolute;
    // top: 0;
    // left: 0;
    height: 100%;
    cursor: pointer;
    user-select: none;
    i {
      font-size: 30px;
      line-height: 24px;
      padding: 8px;
      color: #50708c;
    }
  }
  .center {
    height: 100px;
    display: flex;
    .header_center {
      flex: 1;
      height: 100px;
      display: flex;
      align-items: center;
      position: relative;
      .header_box {
        box-sizing: border-box;
        .box_seach {
          width: 520px;
          height: 41px;
          background-color: #fff;
          border-radius: 6px;
          border: 1px solid #50708c;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          overflow: hidden;
          i {
            width: 50px;
            text-align: center;
          }
          input {
            flex: 1;
            height: 30px;
            font-size: 14px;
            border: none;
            outline: none;
            color: #666;
          }
          .button {
            width: 80px;
            height: 39px;
            line-height: 39px;
            margin-right: -1px;
            text-align: center;
            // background-color: #50708c;
            // border-radius;
            color: #50708c;
            // border-left: 1px solid #50708c;
            cursor: pointer;
            user-select: none;
            font-size: 14px;
            z-index: 999;
          }
        }
      }
    }
  }
  .txt {
    line-height: 30px;
    font-size: 20px;
    color: #50708c;
  }
}
</style>